export const state = {
	isShowProgress: getSavedState('simple.isShowProgress'),
	player : {}, // getSavedState('simple.player'),
	messages : getSavedState('simple.messages'),
	app : {
		isWide: false
	}
}

export const mutations = {
	SET_WIDE_STATE(state, newValue) {
		state.app.isWide = newValue;
	},

  SET_LOADING_PROGRESS(state, newValue) {
		state.isShowProgress = newValue
    saveState('simple.isShowProgress', newValue)
	},
	
	INIT_MESSAGE(state, newValue) {
		state.messages = [];
		saveState('simple.messages', state.messages)
	},

	PUSH_MESSAGE(state, newValue) {
		state.messages = [...state.messages, newValue]
		saveState('simple.messages', state.messages)
	},

	DELETE_MESSAGE(state, newValue) {
		state.messages = state.messages.filter(item => {
			return item.time !== newValue;
		})
		saveState('simple.messages', state.messages)
	},

	INIT_PLAYER(state, newValue) {
		state.player = {isOpen : false, isHide : true}
	},
	
	PLAYER_OPEN(state, newValue) {
		state.player = {...state.player, isOpen : true, isHide : false}
		// saveState('simple.player', state.player)
	},

	PLAYER_HIDE(state, newValue) {
		state.player = {...state.player, isHide : true}
		// saveState('simple.player', state.player)
	},

	PLAYER_PLAY(state, newValue) {
		state.player = {...state.player, ...newValue}
	}

}

export const getters = {
  // Whether the user is currently logged in.
  isShowingProgress(state) {
    return !!state.isShowProgress
	},
	player(state) {
		return state.player
	},
  messages(state) {
    return state.messages
  },
	isWideMode(state) {
		return state.app.isWide;
	}
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch, commit }) {
    // setDefaultAuthHeaders(state)
		commit('INIT_MESSAGE');
		commit('INIT_PLAYER')
		// state.isShowProgress = false;
		// state.messages = [];
  },

  showProgress({ commit, dispatch, getters }) {
    commit('SET_LOADING_PROGRESS', true);
  },

  hideProgress({ commit, dispatch, getters }) {
    commit('SET_LOADING_PROGRESS', false);
  },

	// initMessage({commit, dispatch, getters}) {
	// 	commit('INIT_MESSAGE')
	// },

	pushMessage({ commit, dispatch, getters }, msg, type='primary') {
		commit('PUSH_MESSAGE', {
			msg,
			type,
			time : new Date().getTime()
		});
	},

	deleteMessage({ commit, dispatch, getters }, time) {
		commit('DELETE_MESSAGE', time);
	},

	playerOpen({ commit, dispatch, getters }) {
		commit('PLAYER_OPEN');
	},

	playerHide({ commit, dispatch, getters }) {
		commit('PLAYER_HIDE');
	},

	playerPlay({ commit, dispatch, getters }, {artist, title}) {
		commit('PLAYER_PLAY', {
			artist,
			title,
		});
	},

	setWideMode({commit, dispatch, getters}, state) {
		commit('SET_WIDE_STATE', state)
	}

  // Validates the current user's token and refreshes it
  // with new data from the API.
  // validate({ commit, state }) {
  //   if (!state.currentUser) return Promise.resolve(null)

  //   return axios
  //     .get('/api/session')
  //     .then((response) => {
  //       const user = response.data
  //       commit('SET_CURRENT_USER', user)
  //       return user
  //     })
  //     .catch((error) => {
  //       if (error.response && error.response.status === 401) {
  //         commit('SET_CURRENT_USER', null)
  //       }
  //       return null
  //     })
  // },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}

// function setDefaultAuthHeaders(state) {
//   axios.defaults.headers.common.Authorization = state.currentUser
//     ? state.currentUser.token
//     : ''
// }
